import { defineMessages } from '@sm/intl';

const FORMS = 'Forms - GROW-2529';
const PRICING_DESCRIPTION = '[Type: String][Vis.: high] - A string in pricing footer experiment GROW-2529';

const experimentCopy = defineMessages({
  grow_2529_can_i_build: {
    id: 'Pricing.experimentCopy.CanIBuild',
    defaultMessage: 'Can I build online forms with SurveyMonkey?',
    desc: {
      id: 'Pricing.experimentCopy.CanIBuild',
      message: PRICING_DESCRIPTION,
      project: FORMS,
    },
  },
  grow_2529_all_our_plans: {
    id: 'Pricing.experimentCopy.AllOurPlans',
    defaultMessage:
      'All our plans can be used to build forms. We also crafted the Forms plan specifically for this purpose.',
    desc: {
      id: 'Pricing.experimentCopy.AllOurPlans',
      message: PRICING_DESCRIPTION,
      project: FORMS,
    },
  },
  grow_2529_use_collectors: {
    id: 'Pricing.experimentCopy.UseCollectors',
    defaultMessage: 'Use {number} collectors per form or survey',
    desc: {
      id: 'Pricing.experimentCopy.UseCollectors',
      message: PRICING_DESCRIPTION,
      project: FORMS,
    },
  },
});

export default experimentCopy;
